import SurveyReact from './SurveyReact';

export default SurveyReact;
